import {
  V2TripDetailsResponseManager,
  getTripFareBreakup,
  useItineraryFareBreakup,
  usePartnerFeatures,
} from 'obt-common';
import { getItineraryFareBreakupFromFlightFareBreakup } from 'obt-common/utils/Flights/getItineraryFareBreakupFromFlightFareBreakup';
import { useParams } from 'react-router-dom';
import FareBreakup from '../../shared/FareBreakupContainer/FareBreakup';
import { IRetryPaymentParams } from '../types';
import useGetTripDetailsResponse from '../hooks/useGetTripDetailsResponse';
import useGetPnr from '../hooks/useGetPnr';

/**
 * Creates the farebreakup model and renders with shared fare breakup component
 */
const FareBreakupContent = () => {
  const { pnrId } = useParams<IRetryPaymentParams>();

  const pnr = useGetPnr();
  const tripDetails = useGetTripDetailsResponse();

  // eslint-disable-next-line no-restricted-syntax
  const tripManager = new V2TripDetailsResponseManager(tripDetails);

  const { features } = usePartnerFeatures();
  const { showServiceFeeTax } = features;

  const flightFareBreakup = getTripFareBreakup({ pnr, showServiceFeeTax: showServiceFeeTax ?? false });

  const tripTravelers = tripManager.getAirTravelers(pnrId);

  const getItineraryFareBreakupProps = getItineraryFareBreakupFromFlightFareBreakup({
    flightFareBreakup,
    tripTravelers,
  });

  const fareBreakupModel = useItineraryFareBreakup(getItineraryFareBreakupProps);

  return <FareBreakup breakupData={fareBreakupModel} />;
};

export default FareBreakupContent;
